import { Component, ChangeDetectionStrategy } from '@angular/core';

import { GalaxyCardComponent } from '@app/components/ui/galaxy-card/galaxy-card.component';

@Component({
  selector: 'app-testimonials',
  imports: [GalaxyCardComponent],
  templateUrl: './testimonials.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./testimonials.component.css'],
})
export class TestimonialsComponent {}
